export const LS_ENV_KEY = 'hs_supportal.env.v1';
export const LS_PATIENT_SELECTION_KEY = 'hs_supportal.patientSelection.v1';

export const safeJsonParse = (raw) => {
  if (!raw || typeof raw !== 'string') return null;
  try {
    return JSON.parse(raw);
  } catch (_e) {
    return null;
  }
};

export const getPatientUidFromAny = (patient) => {
  try {
    return (patient?.patient_uid || patient?.data_get?.metadata?.uid || '').toString().trim();
  } catch (_e) {
    return '';
  }
};
